import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BackendTranslationService } from '@root/app/modules/cases/services';
import { DynamicControl } from '@shared/models/dynamic-form-control.model';
import * as moment from 'moment';
import { isNullOrUndefined } from '@shared/utils/utils';
import { FormErrorStateMatcher } from '../error-state-matcher';

@Component({
  selector: 'app-dynamic-form-control',
  templateUrl: './dynamic-form-control.component.html',
  styleUrls: ['./dynamic-form-control.component.scss']
})
export class DynamicFormControlComponent implements OnInit {
  @Input() control: DynamicControl<any>;
  @Input() form: UntypedFormGroup;
  @Output() formValidity: EventEmitter<any> = new EventEmitter();
  @Output() selectedControl: EventEmitter<any> = new EventEmitter();
  @Input() rowIndex: number;
  @Output() addRow: EventEmitter<any> = new EventEmitter();
  @Output() removeRow: EventEmitter<any> = new EventEmitter();
  @Output() rowOrderChanged: EventEmitter<any> = new EventEmitter();
  @Output() valueAutoCompleted: EventEmitter<any> = new EventEmitter();


  public checkControl = false;

  public dateRangeMin: string;
  public dateRangeMax: string;
  public timeSpanMessage: string;
  public fieldLabelToDisplay: string;
  public matcher = new FormErrorStateMatcher();

  constructor(public backendTranslationService: BackendTranslationService) {
  }

  ngOnInit() {
    this.fieldLabelToDisplay = this.control.label;
    if (this.control.rangeValues) {
      if (!isNullOrUndefined(this.control.rangeValues.max) && this.control.rangeValues.max != "") {
        if (this.checkIfAbsoluteDate(this.control.rangeValues.max)) {
          this.dateRangeMax = this.getMoment(this.control.rangeValues.max).format("DD/MM/YYYY");
        }
        else {
          const momentMax = this.getMoment(this.splitRangeValue(this.control.rangeValues.max)[0]);
          const timeSpan = this.getTimeSpan(this.control.rangeValues.max);
          this.dateRangeMax = this.addTimeSpanToDate(this.control.rangeValues.max, timeSpan, momentMax).format("DD/MM/YYYY");
        }
      }
      if (!isNullOrUndefined(this.control.rangeValues.min) && this.control.rangeValues.min != "") {

        if (this.checkIfAbsoluteDate(this.control.rangeValues.min)) {
          this.dateRangeMin = this.getMoment(this.control.rangeValues.min).format("DD/MM/YYYY");
        }
        else {
          const momentMin = this.getMoment(this.splitRangeValue(this.control.rangeValues.min)[0]);
          const timeSpan = this.getTimeSpan(this.control.rangeValues.min);
          this.dateRangeMin = this.addTimeSpanToDate(this.control.rangeValues.min, timeSpan, momentMin).format("DD/MM/YYYY");
        }
      }
    }
  }

  selectControl() {
    this.selectedControl.emit({ controlName: this.control.key, controlValue: this.control.value })
  }

  onPressTab(event: any){
    if(this.control.valueOptions && this.control.valueOptions.length > 0){
      this.control.value = this.control.valueOptions[0];
      this.valueAutoCompleted.emit(this.control.value);
      event.stopPropagation();
      event.preventDefault();
    }
  }

  private splitRangeValue(rangeValue: string) {
    if (rangeValue.includes('-') || rangeValue.includes('+')) {
      return rangeValue.split(/[+-]/g);
    }
    else {
      return [rangeValue];
    }
  }

  private getMoment(date: string) {
    if (date === 'NOW') {
      return moment.utc();
    } else if (date == null) {
      return null;
    } else {
      return moment(date);
    }
  }

  private checkIfAbsoluteDate(date: string) {
    return moment(date).isValid()
  }

  private getTimeSpan(rangeValue: any) {
    if (!isNullOrUndefined(rangeValue)) {
      if (rangeValue.includes('-') || rangeValue.includes('+')) {
        let number = this.splitRangeValue(rangeValue)[1].replace(/\D/g, "");
        if (rangeValue.includes('-')) {
          return parseInt(number) * -1;
        }
        else {
          return parseInt(number);
        }
      }
      else {
        return 0;
      }
    }
    return null;
  }

  private addTimeSpanToDate(timespanType: any, amount: any, date: moment.Moment) {
    if (timespanType.includes('P')) {
      if (timespanType.includes('Y')) {
        //years
        return moment(date).add(amount, "years")
      }
      else if (timespanType.includes('M')) {
        //months
        return moment(date).add(amount, "months")
      }

      else if (timespanType.includes('W')) {
        //weeks
        return moment(date).add(amount, "weeks")
      }

      else if (timespanType.includes('D')) {
        //days
        return moment(date).add(amount, "days")
      }
    } else if (timespanType.includes('T')) {
      if (timespanType.includes('H')) {
        //hours
        return moment(date).add(amount, "hours")
      }
      else if (timespanType.includes('M')) {
        //minutes
        return moment(date).add(amount, "minutes")
      }

      else if (timespanType.includes('S')) {
        //seconds
        return moment(date).add(amount, "seconds")
      }
    }

    return moment(date);

  }

  get isRegexOk() {
    if (this.control.regex !== null) {
      return this.form.controls[this.control.key].valid;
    }

    return true;
  }

  get isMOD97Ok() {
    if (this.control.MOD97 === true) {
      return this.form.controls[this.control.key].valid;
    }

    return true;
  }

  get isRequired() {
    if (this.control.required === true) {
      let value = this.form.controls[this.control.key].value ? this.form.controls[this.control.key].value.toString() : null;
      return !isNullOrUndefined(value) && value.length > 0;
    }

    return true;
  }

  get isDateRangeOk() {
    if (this.control.controlType === 'datepicker') {
      return this.form.controls[this.control.key].valid;
    }

    return true;
  }

  rowAdd(){
    this.addRow.emit({ tableKey: this.control.key });
  }

  rowRemove(event: number){
    this.removeRow.emit({ tableKey: this.control.key, rowIndex: event });
  }

  changeRowOrder(event: any){
    this.rowOrderChanged.emit(event);
  }
}
